module.exports = __webpack_public_path__ + "img/martha-chavez.e30501a6.png";